<template>
  <div
    class="accordion accordion--section"
    aria-label="Accordion Group"
  >
    <accordion-item
      :animated="animated"
      :item-id="1"
      :open="isOpen"
      @accordion-item-selected="toggleOpen"
    >
      <template #item-title>
        <slot name="title" />
      </template>

      <template #item-content>
        <slot name="content" />
      </template>
    </accordion-item>
  </div>
</template>



<script>
  export default {
    name: 'ExpandableSection',

    props: {
      animated: {
        type: Boolean,
        default: true
      },
      autoExpand: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isOpen: false
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.isOpen = this.autoExpand;
      },

      toggleOpen() {
        this.isOpen = !this.isOpen;
      }
    }
  };
</script>
